import { MDCTextField } from '@material/textfield';

const loginInputElement = document.querySelector('.login__form__name');

if (loginInputElement) {
  const loginInput = new MDCTextField(loginInputElement);
}

const passwordInputElement = document.querySelector('.login__form__password');

if (passwordInputElement) {
  const passwordInput = new MDCTextField(passwordInputElement);
}

const passResetInputElement = document.querySelector('.pass-reset__form__name');

if (passResetInputElement) {
  const passResetInput = new MDCTextField(passResetInputElement);
}

const registerInputElements = document.querySelectorAll('.register__form__input');

if (registerInputElements) {
  registerInputElements.forEach(element => {
    const registerInput = new MDCTextField(element);
  });
}
